import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PublicSelectEnumComponent } from '@componentes/public-select/public-select-enum.component';
import {
	ModeloGrade,
	getLabelModeloGrade,
} from '@modulos/home/submodulos/previsao-numerica-tempo/pages/mapas-de-previsao/enums/modelo-grade';

@Component({
	selector: 'seira-public-select-grade',
	templateUrl: './public-select.component.html',
	styleUrls: ['./public-select.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => PublicSelectGradeComponent),
		},
	],
})
export class PublicSelectGradeComponent extends PublicSelectEnumComponent {
	override label = 'Grade';
	override notFoundText = 'Nenhuma grade foi encontrada';
	override placeholder = 'Informe a grade desejada';

	constructor() {
		super(ModeloGrade, getLabelModeloGrade);
	}
}
